import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';
import { Link } from 'react-router-dom';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ position: 'relative', zIndex: 0, display: 'block' }}>

    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}



    <div className='row-to-column max-1200 full-width' style={{ zIndex: 2, position: 'relative', gap: '15px', justifyContent: 'space-between', margin: '15px auto', padding: '30px 10px' }}>
      {/* <div className='column-start' style={{ gap: '5px', width: '100%', maxWidth: '300px' }}>
        <strong style={{ color: '#162743' }}>INSCRIÇÕES</strong>
        <p style={{ color: '#162743' }}>(51) 98033-2025</p>
        <p style={{ color: '#162743' }}>atendimento@tribecaeventos.com.br</p>


      </div>

      <div className='column-start' style={{ gap: '5px', width: '100%', maxWidth: '300px' }}>
        <strong style={{ color: '#162743' }}>SEJA UM PATROCINADOR</strong>
        <p style={{ color: '#162743' }}>(51) 98190-0522</p>
        <p style={{ color: '#162743' }}>elivia@tribecaeventos.com.br</p>


      </div>
*/}


      <p style={{ color: '#fff', fontSize: '14px', maxWidth: '300px', width: '100%' }} className="text-center-mobile">{getYear(new Date())} - © Legado Coop - Todos os direitos reservados.</p>
      <Link to="/politica"><p style={{ color: '#fff', fontSize: '14px', maxWidth: '300px', width: '100%' }} className="text-center-mobile">Política de Reembolso</p></Link>

      {/*   <p style={{ color: '#162743', fontSize: '14px', maxWidth: '400px', width: '100%' }} className="text-center-mobile">
        <strong>Política de Reembolso:</strong><br />
        Enviar e-mail para wlm@cemcerimonia.com.br<br />
        Até 60 dias antes da realização – 85% do valor<br />
        Entre 59 e 45 dias antes da realização – 50% do valor<br />
        Até 44 dias antes da realização – Não haverá reembolso

</p> */}
      <ContactIcons color="#fff" />
    </div>
  </div>
    {/* <Particles
      params={{
        particles: {
          lineLinked: {
            enable: false,
            distance: 550,
            color: '#99dcce'
          },
          move: {
            speed: 1.5,
            direction: 'top-right',
            collisions: false,
            outModes: {
              default: 'out',
              left: 'out',
              right: 'out',
              bottom: 'out',
              top: 'out',
            },


          },
          opacity: {
            value: 1,
            random: false,
            animation: {
              enable: false
            }

          },
          shape: {
            type: 'circle',
            polygon: {

              nb_sides: 6,

            },

          },

          color: { value: ['#99dcce', '#33baab', '#489c4'] },

          number: {
            density: {
              enable: true,
              value_area: 2400,
            },
            value: 60,
          },
          size: {
            value: 4,
            random: true,
          },
        },
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: -1
      }}
    />*/}
  </>
  );
};

export default FooterLayout;
